import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '../components/primitives/Button';
import { Container } from '../components/primitives/Container';
import { useContent } from '../content/load';

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 420px;
  padding: ${(p) => p.theme.step[7]}px 0;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: ${(p) => p.theme.step[1]}px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${(p) => p.theme.color.text[3]};

  input, select {
    background: ${(p) => p.theme.color.bg[2]};
    border: 1px solid ${(p) => p.theme.color.border.med};
    color: ${(p) => p.theme.color.text[0]};
    border-radius: 6px;
    padding: 10px 12px;
    font-family: inherit;
    font-size: ${(p) => p.theme.step[3]}px;
    text-transform: none;
    letter-spacing: 0;
  }
`;

export default function Signup() {
  const { tiers } = useContent();
  const nav = useNavigate();
  return (
    <Container>
      <h1 style={{ fontFamily: 'var(--font-serif)', margin: 0 }}>Create your account</h1>
      <p style={{ color: 'var(--text-2)' }}>Mock signup — proceeds straight to the dashboard.</p>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          nav('/dashboard');
        }}
      >
        <Field>
          Email
          <input type="email" required defaultValue="trader@powerquant.com" />
        </Field>
        <Field>
          Password
          <input type="password" required defaultValue="••••••••" />
        </Field>
        <Field>
          Tier
          <select>
            {tiers.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name} — {typeof t.price === 'number' ? `$${t.price}/mo` : t.price}
              </option>
            ))}
          </select>
        </Field>
        <Button type="submit" $variant="primary">
          Create account
        </Button>
        <p style={{ color: 'var(--text-3)', fontSize: 12 }}>
          Already have one? <Link to="/login">Sign in</Link>.
        </p>
      </Form>
    </Container>
  );
}
